import { useCallback } from "react";
import IRequest from "../../../types/IRequest";
import { IDataFluxos } from "../../../types/api/configuracoes/pesquisar-fluxos";
import { useNavigate } from "react-router-dom";
import SessaoConfiguracao, { ConfiguracaoColunas } from "../../../components/BasicComponents/DisplayDados/SessaoConfiguracao";

export default function Fluxos() {

    const navigate = useNavigate();

    const handleRedirectDetail = useCallback((id: number) => {
        navigate(`/configuracoes/fluxo/${id}`)
    }, [navigate])

    return (
        <SessaoConfiguracao<IDataFluxos>
            titulo="Fluxos"
            endpoints={{
                listar: "pesquisar-fluxos",
                deletar: "nenhuma-rota-cadastrada",
            }}
            colunas={colunas}
            queryKey="pesquisar-fluxos"
            onEditar={(fluxo) => {
                handleRedirectDetail(fluxo.id)
            }}
            possuiAdicionar={false}
            mensagemSucessoDeletar="Fluxo deletado com sucesso!"
            mensagemErroDeletar="Erro ao deletar fluxo!"
            mensagemSemDados="Nenhum fluxo encontrado."
        />
    )
}
export interface IFluxos {
    reqFluxos: IRequest<IDataFluxos>,
    dataFluxos: IDataFluxos[]
}

export type TOpenModal = number | boolean | null

const colunas: ConfiguracaoColunas<IDataFluxos>[] = [
    {
        campo: "nome",
        titulo: "Nome",
    },
    {
        campo: "versao",
        titulo: "Versão",
    },
    {
        campo: "modulo",
        titulo: "Modulo",
    }
];